import React, { useMemo, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Edit, List } from '@material-ui/icons';
import ReactDOM from 'react-dom';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import { SecondaryButton } from '../../../Core/FormInput';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import DialogComp from '../../../Core/Modal/dialogModal';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import AddEditInspectionSheetList from './addEditModal';
import InspectionSheetListOption from './inspectionSheetListOption';

const InspectionSheetList = () => {
    const [state, setState] = useState({
        showAddEdit: false,
        showOptions: false,
        focusedRow: null,
        isReload: new Date()
    });

    const baseColumns = [
        {
            field: 'action',
            sortable: false,
            title: 'Action',
            width: '10%',
            filterable: false
        },
        {
            field: 'listId',
            title: 'ID',
            hidden: true
        },
        {
            field: 'listName',
            title: 'Description',
            width: '90%'
        }
    ];

    const crumbs = () => [
        { name: 'Home', path: '/' },
        { name: 'Inspection Sheet Lists', active: true }
    ];

    const actionRenderer = (field) => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly" style={{ display: 'flex', gap: '5px', justifyContent: 'center', alignItems: 'center' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px'
                    }}
                    onClick={() => handleAddEdit(true, record)}
                >
                    <Edit fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px'
                    }}
                    onClick={() => handleOptions(record)}
                >
                    <List fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = actionRenderer({});
        }

        return tempCols;
    }, []);

    const handleAddEdit = (val, record = null) => {
        if (val) {
            setState((st) => ({
                ...st,
                showAddEdit: val,
                focusedRow: record,
                isReload: false
            }));
        } else {
            setState((st) => ({
                ...st,
                showAddEdit: val,
                focusedRow: null,
                isReload: new Date()
            }));
        }
    };

    const handleOptions = (record) => {
        setState((st) => ({
            ...st,
            showOptions: true,
            focusedRow: record
        }));
    };

    const closeOptionsModal = (res) => {
        setState((st) => ({
            ...st,
            showOptions: false,
            focusedRow: null,
            isReload: res ? new Date() : st.isReload
        }));
    };

    const baseUrl = 'InspectionSheetList';

    const addEditTitle = state.focusedRow ? 'Update Inspection Sheet List' : 'Add Inspection Sheet List';
    const optionsTitle = state.focusedRow ? `Manage Options - ${state.focusedRow.listName}` : 'Manage Options';

    return (
        <div>
            <Grid item container justify="space-between">
                <Grid item>
                    <BreadCrumbs crumbs={crumbs()} />
                </Grid>
                <Grid item style={{ marginTop: '15px' }}>
                    <SecondaryButton
                        variant="contained"
                        color="secondary"
                        onClick={() => handleAddEdit(true, null)}
                        className="btnadd"
                    >
                        Add Inspection Sheet List
                    </SecondaryButton>
                </Grid>
            </Grid>

            <Grid item container spacing={1} xs={12} style={{ marginTop: '-25px' }}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data || [],
                            total: res?.data?.length || 0
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                    />
                </Grid>
            </Grid>

            {state.showAddEdit && (
                <DialogComp
                    title={addEditTitle}
                    maxWidth="sm"
                    onClose={() => handleAddEdit(false)}
                    fullWidth
                >
                    <AddEditInspectionSheetList
                        listData={state.focusedRow}
                        onFormSubmit={() => handleAddEdit(false)}
                    />
                </DialogComp>
            )}

            {state.showOptions && state.focusedRow && (
                <DialogComp
                    title={optionsTitle}
                    maxWidth="lg"
                    onClose={() => closeOptionsModal(false)}
                    fullWidth
                    overflow="auto"
                >
                    <InspectionSheetListOption
                        listId={state.focusedRow.listId || state.focusedRow.id}
                        onFormSubmit={() => closeOptionsModal(true)}
                    />
                </DialogComp>
            )}
        </div>
    );
};

export default InspectionSheetList;
